import { IdName } from '@lib/utils/id-name';
import { Combobox } from '@servicetitan/anvil2';
import { BodyText, Icon } from '@servicetitan/design-system';
import { FC, Fragment, useState } from 'react';
import styles from './TenantSelect.module.css';
import { inboxLocators } from '@locators/inbox';

export interface TenantSelectProps {
  onTenantSelect: (tenant: IdName | null) => void;
  tenantOptions: IdName[];
  selectedTenant?: IdName | null;
  defaultOption?: IdName | null;
}

export const TenantSelect: FC<TenantSelectProps> = ({
  onTenantSelect,
  tenantOptions,
  selectedTenant,
  defaultOption = null,
}) => {
  const [touched, setTouched] = useState(false);

  const onChange = (tenant: IdName | null) => {
    onTenantSelect(tenant ?? defaultOption);
    setTouched(true);
  };

  return (
    <Fragment>
      <Combobox
        items={tenantOptions}
        itemToString={(item) => item?.name ?? ''}
        itemToKey={(item) => item?.id ?? null}
        selectedItem={selectedTenant}
        onChange={onChange}
        filterOptions={{ keys: ['name'] }}
      >
        <Combobox.SearchField
          placeholder='Search...'
          error={touched && !selectedTenant}
          required={true}
          size='small'
          data-testid={inboxLocators.callBar.outboundCallModalSelectedTenant}
        />

        <Combobox.Content className={styles.tenantSelectContent}>
          {({ items }) => (
            <Combobox.List>
              {items.map((item, key) => (
                <Combobox.Item key={item.id} item={item} index={key}>
                  {item.name}
                </Combobox.Item>
              ))}
            </Combobox.List>
          )}
        </Combobox.Content>
      </Combobox>

      {touched && !selectedTenant && (
        <BodyText size='small' className='c-red-500'>
          <Icon name='warning' color='red' className='m-r-half' />
          Select an account to call from
        </BodyText>
      )}
    </Fragment>
  );
};
